import React from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Outlet, Route, Routes } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import StoriesList from "./pages/StoriesList";
import StoryPost from "./pages/StoryPost";
import ScrollToTop from "./components/ScrollToTop";
import Playground from "./pages/Playground";
import NotFound from "./pages/NotFound";
import Offers from "./pages/Offers";
import OfferPoc from "./pages/OfferPoc";
import OfferAutomation from "./pages/OfferAutomation";
import OfferWorkshop from "./pages/OfferWorkshop";
import Privacy from "./pages/Privacy";
import Company from "./pages/Company";
import Dimop from "./pages/Dimop";
import { DIMOP_ENABLED } from "./config/flags";
import { LangLayout } from "./i18n/LangContext";
import { LANGUAGES, DEFAULT_LANGUAGE } from "./i18n";

// One copy of the page tree per language: English at /, Hungarian at /hu, Serbian at /sr.
// A function rather than a constant because /hu has one route the others do not.
const pagesFor = (lang) => (
  <>
    <Route index element={<Home />} />
    <Route path="about" element={<About />} />
    <Route path="offers" element={<Offers />} />
    <Route path="offers/poc" element={<OfferPoc />} />
    <Route path="offers/automation" element={<OfferAutomation />} />
    <Route path="offers/workshop" element={<OfferWorkshop />} />
    <Route path="career" element={<Career />} />
    <Route path="contact" element={<Contact />} />
    <Route path="playground" element={<Playground />} />
    <Route path="thank-you" element={<ThankYou />} />
    <Route path="stories" element={<StoriesList />} />
    <Route path="stories/:slug" element={<StoryPost />} />
    {DIMOP_ENABLED && lang === "hu" && <Route path="dimop" element={<Dimop />} />}
    <Route path="privacy" element={<Privacy />} />
    <Route path="company" element={<Company />} />
    <Route path="*" element={<NotFound />} />
  </>
);

const Shell = () => {
  const { t } = useTranslation();
  return (
    <>
      <a className="skip-link" href="#main">{t("nav.skip")}</a>
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {LANGUAGES.map(({ code }) => (
          <Route
            key={code}
            path={code === DEFAULT_LANGUAGE ? "/" : `/${code}`}
            element={
              <LangLayout lang={code}>
                <Shell />
              </LangLayout>
            }
          >
            {pagesFor(code)}
          </Route>
        ))}
      </Routes>
    </Router>
  );
};

export default App;
